import Promo from '../promo';
import PropTypes from 'prop-types';

const PromoCustomCta = ({headline, description, cta}) => {
	return (
		<Promo headline={headline} description={description} cta={cta} ctaBgLight={true}/>
	);
};

PromoCustomCta.propTypes = {
	headline: PropTypes.string.isRequired,
	description: PropTypes.shape({ description: PropTypes.string.isRequired }),
	cta: PropTypes.shape({
		title: PropTypes.string,
		link: PropTypes.string,
	})
};

export default PromoCustomCta;
